import React, { FC } from 'react';
import { CantFindYourDreamCarProps } from '.';
import useTranslations from '@hooks/useTranslations';
import Button from '@components/Button';
import { useOrdelPanelLogic } from '@hooks/useOrdelPanelLogic';
const CantFindYourDreamCarTemplate: FC<CantFindYourDreamCarProps> = ({ className }) => {
    const { t } = useTranslations();
    const { redirectToMTO } = useOrdelPanelLogic();

    return (
        <div className={className}>
            <div className="content">
                <div className="txt">
                    <span>{t('cantFindYourDreamCar')}</span>
                    <span>{t('configureIt')}</span>
                </div>

                <Button secondary id="TESTING_BANNER_LINK" onClick={redirectToMTO}>
                    {t('btn.cantFindYourDreamCar.configure')}
                </Button>
            </div>
            <div className="img" />
        </div>
    );
};
export default CantFindYourDreamCarTemplate;
